var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgAvatarSmall = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 45,
  height: 45,
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
  width: 45,
  height: 45,
  rx: 22.5,
  fill: "#0564AA"
})), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M22.5 7.467c-8.284 0-15.033 6.749-15.033 15.034S14.216 37.535 22.5 37.535s15.034-6.75 15.034-15.034c0-8.285-6.75-15.034-15.034-15.034Zm0 2.313A12.705 12.705 0 0 1 35.223 22.5c0 3.1-1.102 5.928-2.927 8.132a10.459 10.459 0 0 0-5.891-6.207 5.76 5.76 0 0 0 1.88-4.237c0-3.18-2.603-5.782-5.783-5.782s-5.783 2.602-5.783 5.782a5.76 5.76 0 0 0 1.88 4.237c-2.747 1.12-4.888 3.388-5.882 6.207a12.656 12.656 0 0 1-2.936-8.131A12.705 12.705 0 0 1 22.5 9.78Zm0 6.938a3.447 3.447 0 0 1 3.47 3.47 3.447 3.447 0 0 1-3.47 3.47 3.447 3.447 0 0 1-3.468-3.47 3.447 3.447 0 0 1 3.469-3.47Zm0 9.252c3.931 0 7.157 2.792 7.906 6.496a12.667 12.667 0 0 1-7.905 2.756c-2.99 0-5.728-1.03-7.897-2.756.741-3.704 3.967-6.496 7.897-6.496Z",
  fill: "#fff"
})));
export default SvgAvatarSmall;